interface ConfigType {
  API_HOST: string;
  ASSETS_HOST: string;
  CLIENT_ID: string;
  PRODUCT_SEARCH_URL: string;
  DEPLOYMENT_ROUTE: string;
  MARKETPLACE_URL: string;
}


const defaultConfig: ConfigType = {
  API_HOST: incubationApiUrl != undefined ? incubationApiUrl : "https://api.syf.com",
ASSETS_HOST: joyhuntAssetsHostUrl != undefined ? joyhuntAssetsHostUrl :
  "https://images.synchronycredit.com/assets/incubation/marketplace",
CLIENT_ID: joyhuntClientId != undefined ? joyhuntClientId : "AjnaIKJolyzfn5NsUb2j9YGy1JcshbVE",
PRODUCT_SEARCH_URL: incubationApiSearchUrl != undefined ? incubationApiSearchUrl : "https://api.syf.com/v1/incubation/products",
DEPLOYMENT_ROUTE: "searchinspiration",
MARKETPLACE_URL: envHost != undefined ? envHost+ (envHost.includes("/sites") ? "syc/marketplace" : "/marketplace") : "https://www.synchrony.com/marketplace",
};

// console.log(defaultConfig);

export const localConfig: ConfigType = {
API_HOST: "https://api-dev.prvcld.syfbank.com",
ASSETS_HOST:
  "https://images.synchronycredit.com/assets/incubation/marketplace",
CLIENT_ID: "gSSQBdwSXdaqTDI06QDOKNLc6Y8tetFh",
PRODUCT_SEARCH_URL: "https://api-dev.prvcld.syfbank.com/v1/incubation/products",
DEPLOYMENT_ROUTE: "searchinspiration",
MARKETPLACE_URL: "https://qwww.synchrony.com/marketplace",
};

export const MAX_CHARACTER_LIMIT = 151;
export const HOME_FURNISHING_URL =
  "https://www.synchrony.com/marketplace/home-furnishings";
export const HOME_FURNISHING_QA_URL =
  "https://qwww.synchrony.com/marketplace/home-furnishings";
export const SYNCHRONY_URL = "https://www.synchrony.com/";
export const SYNCHRONY_QA_URL = "https://qwww.synchrony.com/";
export default (env && env.includes("SYC")) ? defaultConfig : localConfig;
